import {
    CheckCircleFilled,
    CloseCircleOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import React from "react";
import { $t } from "~/i18n.js";
import { _parseDate } from "~/lib/localize.js";
import { colors } from "~/theme/colors.js";

export const KNVVLStatus = ({ association, userGroups = [] }) => {
  // if user not in basic_instructor or instructeur or zweefvlieger, show nothing
  if (
    !userGroups.includes("basic_instructor") &&
    !userGroups.includes("instructeur") &&
    !userGroups.includes("zweefvlieger")
  ) {
    return null;
  }

  if (!association || !association.end) {
    return (
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <CloseCircleOutlined style={{ color: colors.red, fontSize: 16 }} />
        <span style={{ color: colors.gray }}>{$t("Geen data")}</span>
      </div>
    );
  }

  const endDate = dayjs(association.end);
  const isValid = endDate.isAfter(dayjs());

  return (
    <div style={{ display: "flex", gap: 8 }}>
      {isValid ? (
        <CheckCircleFilled style={{ color: colors.groen_dark, fontSize: 16 }} />
      ) : (
        <CloseCircleOutlined style={{ color: colors.red, fontSize: 16 }} />
      )}
      <span>
        {association.name} ({_parseDate(association.end)})
      </span>
    </div>
  );
};
